(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ew-quick-filters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quick-filter-pills')) {
    class QuickFilterPills extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('.quick-filter-pills__list');

        if (!(list instanceof HTMLElement)) return;
        if (!this.querySelector('[data-quick-filter-pill]')) return;

        this.list = list;
        this.previousArrow = this.querySelector('[data-quick-filter-arrow="-1"]');
        this.nextArrow = this.querySelector('[data-quick-filter-arrow="1"]');
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onFilterUpdate = this.onFilterUpdate.bind(this);
        this.onPopState = this.onPopState.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('shopify:collection:update', this.onFilterUpdate);
        window.addEventListener('popstate', this.onPopState);
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.syncPills();
        this.updateScrollFade();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('shopify:collection:update', this.onFilterUpdate);
        window.removeEventListener('popstate', this.onPopState);
        this.list?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);

        if (this.scrollFrame) {
          window.cancelAnimationFrame(this.scrollFrame);
        }
      }

      /**
       * Builds a new URL from the pill parameter, value, and current state.
       * Resets pagination and adds or removes the filter value based on whether it is active.
       * @param {string} param - Shopify filter parameter for the pill.
       * @param {string} value - Filter value for the pill.
       * @param {boolean} active - Whether the pill is active in the current URL.
       * @returns {URL} Rebuilt target URL.
       */
      buildURL(param, value, active) {
        const url = new URL(window.location.href);
        const values = url.searchParams.getAll(param);

        url.searchParams.delete('page');
        url.searchParams.delete(param);

        values
          .filter((entry) => (active ? entry !== value : true))
          .forEach((entry) => url.searchParams.append(param, entry));

        if (!active) {
          url.searchParams.append(param, value);
        }

        return url;
      }

      /**
       * Syncs the pressed state of all pills with the URL.
       * @returns {void}
       */
      syncPills() {
        const currentUrl = new URL(window.location.href);
        const pills = this.querySelectorAll('[data-quick-filter-pill]');

        pills.forEach((pill) => {
          const param = pill.dataset.filterParam;
          const value = pill.dataset.filterValue;

          if (!param || !value) return;

          const isActive = currentUrl.searchParams.getAll(param).includes(value);

          pill.setAttribute('aria-pressed', String(isActive));
        });
      }

      onFilterUpdate() {
        window.requestAnimationFrame(() => {
          this.syncPills();
          this.updateScrollFade();
        });
      }

      onPopState() {
        this.syncPills();
      }

      onScroll() {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateScrollFade();
        });
      }

      onResize() {
        this.updateScrollFade();
      }

      /**
       * Updates the start/end fade mask and the arrows based on how far the pill list has been scrolled.
       * @returns {void}
       */
      updateScrollFade() {
        if (!(this.list instanceof HTMLElement)) return;

        const { scrollLeft, scrollWidth, clientWidth } = this.list;
        const atStart = scrollLeft <= 0;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

        this.style.setProperty('--quick-filter-fade-start', atStart ? '1' : '0');
        this.style.setProperty('--quick-filter-fade-end', atEnd ? '1' : '0');

        if (this.previousArrow instanceof HTMLElement) this.previousArrow.hidden = atStart;
        if (this.nextArrow instanceof HTMLElement) this.nextArrow.hidden = atEnd;
      }

      /**
       * Space toggles a pill like a button (links only react to Enter).
       * @param {KeyboardEvent} event - Triggered keydown event.
       * @returns {void}
       */
      onKeyDown(event) {
        if (event.key !== ' ' || !(event.target instanceof Element)) return;

        const pill = event.target.closest('[data-quick-filter-pill]');

        if (!(pill instanceof HTMLAnchorElement)) return;

        event.preventDefault();
        pill.click();
      }

      /**
       * Delegates pill clicks to the facet system or falls back to browser navigation.
       * @param {MouseEvent} event - Triggered click event.
       * @returns {void}
       */
      onClick(event) {
        if (!(event.target instanceof Element)) return;

        const arrow = event.target.closest('[data-quick-filter-arrow]');

        if (arrow instanceof HTMLElement) {
          // EW CUSTOM: scroll by most of the visible width, keep one pill as orientation
          const direction = Number(arrow.dataset.quickFilterArrow);
          // EW CUSTOM: no smooth scrolling with reduced motion
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          this.list.scrollBy({ left: direction * this.list.clientWidth * 0.8, behavior });
          return;
        }

        const pill = event.target.closest('[data-quick-filter-pill]');

        if (!(pill instanceof HTMLAnchorElement)) return;

        // EW CUSTOM: modified clicks open the tag page like a normal link
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const { filterParam, filterValue } = pill.dataset;

        if (!filterParam || !filterValue) return;

        event.preventDefault();

        const url = this.buildURL(filterParam, filterValue, pill.getAttribute('aria-pressed') === 'true').toString();
        const facetsForm = document.querySelector('facets-form-component');

        if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
          facetsForm.updateFiltersByURL(url);
        } else {
          window.location.assign(url);
        }
      }
    }

    /**
     * Registers the custom element for quick-filter-pills markup.
     */
    customElements.define('quick-filter-pills', QuickFilterPills);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
